import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT } from '../../../foundations/typography';
export const textAreaCommonStyles = (FOUNDATIONS, FONT) => ({
    resize: 'none',
    width: '100%',
    background_color: FOUNDATIONS.color_comp_forms_input_bg,
    border_style: 'none',
    font_size: FONT.font_paragraph_200[DeviceBreakpointsType.DESKTOP].font_size,
    line_height: FONT.font_paragraph_200[DeviceBreakpointsType.DESKTOP].line_height,
    font_weight: FONT_WEIGHT.font_regular,
    color: FOUNDATIONS.color_comp_forms_input_filled_font,
    padding: FOUNDATIONS.spacing_00,
});
export const containerCommonStyles = (FOUNDATIONS, FONT) => ({
    width: ' 100%',
    display: 'flex',
    flex_direction: 'column',
    row_gap: FOUNDATIONS.spacing_150,
});
export const contentCommonStyles = (FOUNDATIONS, FONT) => ({
    width: ' 100%',
    display: 'flex',
    flex_direction: 'row',
    column_gap: FOUNDATIONS.spacing_150,
    background_color: FOUNDATIONS.color_comp_forms_input_bg,
    outline: `${FOUNDATIONS.color_comp_forms_input_filled_border} solid ${FOUNDATIONS.border_50}`,
    border_radius: FOUNDATIONS.radius_200,
    padding: FOUNDATIONS.spacing_200,
});
export const bottomContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    width: '100%',
    flex_direction: 'row',
    align_items: 'flex-end',
    justify_content: 'space-between',
});
export const errorContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    align_items: 'center',
    gap: FOUNDATIONS.spacing_100,
    margin_bottom: FOUNDATIONS.spacing_100,
});
//# sourceMappingURL=container.js.map